module.exports = __webpack_public_path__ + "static/img/ent-detail-22.146a82c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-22.jpg
// module id = o+pX
// module chunks = 51